import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/imacuser/Downloads/silk_export/src/app/market-updates/components/MarketUpdatesInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/imacuser/Downloads/silk_export/src/components/common/Header.tsx");
